"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNCLEAR_REPLY_LIMIT = exports.ORDER_CHANNELS = exports.isTallyReady = exports.missingForTally = exports.OrderState = void 0;
var OrderState;
(function (OrderState) {
    OrderState["RECEIVED"] = "RECEIVED";
    OrderState["PARSING"] = "PARSING";
    OrderState["NEEDS_INFO"] = "NEEDS_INFO";
    OrderState["MATCHED"] = "MATCHED";
    OrderState["READY"] = "READY";
    OrderState["APPROVED"] = "APPROVED";
    OrderState["POSTING"] = "POSTING";
    OrderState["POSTED"] = "POSTED";
    OrderState["FAILED"] = "FAILED";
    OrderState["CANCELLED"] = "CANCELLED";
})(OrderState || (exports.OrderState = OrderState = {}));
/** Fields a line still lacks before Tally can post it. API, web and connector share this rule. */
const missingForTally = (line) => {
    const missing = [];
    if (!line.itemCode)
        missing.push('itemCode');
    if (!line.tallyName)
        missing.push('tallyName');
    if (!line.baseUnit)
        missing.push('baseUnit');
    if (typeof line.baseQty !== 'number' || !(line.baseQty > 0))
        missing.push('baseQty');
    return missing;
};
exports.missingForTally = missingForTally;
const isTallyReady = (line) => (0, exports.missingForTally)(line).length === 0;
exports.isTallyReady = isTallyReady;
exports.ORDER_CHANNELS = ['whatsapp', 'salesman', 'phone_order'];
/** Unclear replies that flag an order for staff; the bot asks once more after this, then stops. */
exports.UNCLEAR_REPLY_LIMIT = 2;
//# sourceMappingURL=order.js.map